import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import React, { Component } from 'react'

const guideKeyList = {
  anyDevice: 'ef5ebb6c-b1ce-4911-0df0-08d7b112fb4d',
}

interface Props {
  isOpen?: boolean;
  onRequestClose?: () => void;
}

interface State {
  widgetDisplayed: boolean;
}

class HolidayLabModal extends Component<React.PropsWithChildren<Props>, State> {
  state = { widgetDisplayed: false }

  executeHolidayLab = () => {
    if (!window.crypto) { // Adapter to make Preezie code compatible to ie
      (window as any).crypto = (window as any).msCrypto
    }
    const guideKey = guideKeyList.anyDevice
    window.PREEZIE_GUIDE.render([
      { guideKey, version: '1.0.0', renderTo: 'preezie-widget-div-id' },
    ])
  }

  // A little hack to ensure HL is executed after widget is rendered
  displayWidget = () => {
    this.setState({ widgetDisplayed: true }, () => this.executeHolidayLab())
  }

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.displayWidget()
    }
  }

  render() {
    return (
      <ModalBase
        height="full"
        isOpen={this.props.isOpen}
        onClose={this.props.onRequestClose}
      >
        <ModalBody>
          <ModalContent>
            {this.state.widgetDisplayed && <div id="preezie-widget-div-id"></div>}
          </ModalContent>
        </ModalBody>
      </ModalBase>
    )
  }
}

export default HolidayLabModal
